import React from "react";
import {Button, Icon, Modal, notification, Tag, Typography} from "antd";
import PropTypes from "prop-types";
import {sanitizeFieldName} from "../../util/methods";
import DocumentCreate from "../../containers/Document/create";
import {fetchSubDocumentFilter} from "../../appRedux/actions";
import {deleteResource} from '../../appRedux/actions/Document';
import {connect} from "react-redux";
import * as moment from 'moment';

const {Title} = Typography;

class DocumentList extends React.Component {

  id = 0;
  state = {
    visible: false,
    documentDataList: [],
    editDocumentData: [],
    currentIndexOfEditDoc: null,
  };

  componentDidMount() {
    this.props.fetchSubDocumentFilter('Document');
    const {data = []} = this.props;
    this.setState({
      documentDataList: data
    })
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.data && JSON.stringify(nextProps.data) !== JSON.stringify(this.props.data)) {
      this.setState({
        documentDataList: nextProps.data
      })
    }
  }

  remove = index => {
    const {documentDataList} = this.state;
    documentDataList.splice(index, 1);
    this.setState({
      documentDataList: documentDataList
    }, () => {
      this.props.getDocumentData(documentDataList);
    });
  };

  // editDocument=index=>{
  //   this.state.editDocumentData=this.state.documentDataList[index];
  //   this.setState({
  //     visible: true,
  //     currentIndexOfEditDoc: index,
  //   });
  // }

  showModal = (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.setState({
      visible: true,
    });
  };

  handleCancel = e => {
    this.setState({
      visible: false,
    });
  };

  handleChange = (e) => {
  };

  handleSubmit = (values, id) => {
    const {documentDataList} = this.state;
    const data = {
      file: values.files.file,
      name: values.name,
      renewalDate: values.renewalDate,
      documentDate: values.documentDate,
      type: values.type,
      docTypeObject: values.docType,
      amount: values.amount || 0,
    };
    let overlappedFlag = false;
    let fixedOverlapped = [];
    if(data.docTypeObject.isOverlappedDisabled) {
      const overlapped = documentDataList.map(doc => {
        // console.log(data.docTypeObject, doc.type);
        if(data.docTypeObject && doc.type && data.docTypeObject._id === doc.type._id) {
          const {documentDate, renewalDate} = doc;
          const {documentDate: currentDocumentDate, renewalDate: currentRenewalDate} = data;
          if(moment(currentDocumentDate).isBetween(moment(documentDate).format('YYYY-MM-DD'), moment(renewalDate).format('YYYY-MM-DD'), undefined, '[]')
            || moment(currentRenewalDate).isBetween(moment(documentDate).format('YYYY-MM-DD'), moment(renewalDate).format('YYYY-MM-DD'), undefined, '[]')) {
            return {documentName: data.name, overlappedDocumentName: doc.name, overlappedDocumentId: doc._id}; //`${data.name} has been overlapped with ${doc.name}`;
          }
        }
      });
      fixedOverlapped = overlapped.filter(o => o);
      if(fixedOverlapped && fixedOverlapped.length)
        overlappedFlag = true;
    }
    // check for overlapped
    if(!overlappedFlag) {
      documentDataList.push(data);
      this.setState({
        documentDataList: documentDataList,
        visible: false
      }, () => {
        this.props.getDocumentData(documentDataList);
      });
    } else {
      // message.error(`Cannot upload ! ${fixedOverlapped.join('/')}`);
      fixedOverlapped.map((msg, key) => {
        notification.error({
          key,
          duration: 30,
          message: `Upload Error!`,
          description: <>
            <Title level={4}>{`Document ${msg.documentName} is overlapped with ${msg.overlappedDocumentName}`}</Title>
            <a target='_blank'
               href={`/document/edit/${msg.overlappedDocumentId}`}>{`Edit ${msg.overlappedDocumentName}`}</a>
          </>,
        })
      });
      this.setState({
        visible: false
      }, () => {
        this.props.getDocumentData(documentDataList);
      })
    }
  };

  edit = (id) => {
    this.props.history.push(`/document/edit/${id}`);
  };

  deletePermanent = (id, index) => {
    const {documentDataList} = this.state;
    documentDataList.splice(index, 1);
    this.setState({
      documentDataList: documentDataList
    }, () => {
      this.props.getDocumentData(documentDataList);
    });
    const flag = true;
    this.props.deleteResource(id, flag);
  }

  render() {
    const {
      item,
      isDisabled,
      hideEdit = false,
      hideRemove = false,
      subDocumentFilters,
      data,
      clearData = false,
      title = '',
      resource = '',
      disableAdd = false
    } = this.props;
    const {viewOption} = this.props;
    const {visible, documentDataList} = this.state;
    const style = {
      marginTop: '10px',
      border: '1px dashed #000',
      padding: '20px',
      borderRadius: '9px',
      display: 'flex',
      justifyContent: 'space-between'
    };
    const formItems = documentDataList && documentDataList.map((itm, index) => {
      if(this.props.resource === 'PreVerificationApproval') {
        return <div key={`${itm._id}${index}`} style={style}>
          <div>
            {(itm.type && itm.type.name) ?
              <Tag color={'blue'}>{itm.type.name} </Tag> : ''}{itm.name} - <span> {itm && itm.url ?
            <a href={itm && itm.url} target="_blank">{itm && itm.url}</a> :
            <span>{itm && itm.name}</span>
          }
          </span>
          </div>
          <div>
            {itm._id ? <Button
              disabled={(viewOption && viewOption.resourceName === 'salesInvoice' && viewOption.viewOption === true) ? true : hideEdit || isDisabled}
              type='primary' onClick={() => {
              this.edit(itm._id)
            }}>Edit</Button> : ''}
            <Button
              type='danger'
              style={{marginLeft: '15px'}}
              disabled={(viewOption && viewOption.resourceName === 'salesInvoice' && viewOption.viewOption === true) ? true : hideRemove || isDisabled}
              onClick={() => this.remove(`${index}`)}
            >Remove</Button>
          </div>
        </div>
      } else {
        return <div key={index} style={style}>
          <div>
            {(itm.type && itm.type.name) ?
              <Tag color={'blue'}>{itm.type.name} </Tag> : ''}{itm.name} - <span>{itm && itm.file && itm.file.path ?
            <a href={itm && itm.file && itm.file.path} target="_blank">{itm && itm.file && itm.file.name}</a> :
            <span>{itm && itm.file && itm.file.name}</span>}</span>
          </div>
          <div>
            {/*{itm._id ? <Button disabled={(viewOption && viewOption.resourceName==='salesInvoice' &&  viewOption.viewOption===true)? true  : hideEdit || isDisabled} type='primary' onClick={() => {this.edit(itm._id)}}>Edit</Button> : ''}*/}
            {itm._id ? <Button type='primary' onClick={() => {
              this.edit(itm._id)
            }}>Edit</Button> : ''}
            {/*{itm._id ?'':<Button*/}
            {/*  type='primary'*/}
            {/*  disabled={ false}*/}
            {/*  onClick={() => this.editDocument(`${index}`)}*/}
            {/*>Edit Doc</Button>*/}
            {/*}*/}
            {/*{itm._id ? <Button type='primary' onClick={() => {*/}
            {/*  this.deletePermanent(itm._id, `${index}`)*/}
            {/*}}>Delete Document</Button> : ''}*/}
            <Button
              type='danger'
              disabled={(viewOption && viewOption.resourceName === 'salesInvoice' && viewOption.viewOption === true) ? true : hideRemove || isDisabled}
              onClick={() => this.remove(`${index}`)}
            >Remove</Button>
          </div>
        </div>
      }
    });
    return (
      <div
        style={resource && (resource === 'ThirdPartyWorkQuotation' || resource === 'InvoiceEntry') ? {width: '48%'} : {width: '100%'}}>
        <Modal
          title="Document"
          visible={(viewOption && viewOption.resourceName === 'salesInvoice' && viewOption.viewOption === true) ? false : visible}
          onOk={this.handleOk}
          onCancel={this.handleCancel}
          footer={null}
        >
          <DocumentCreate data={data}
                          filters={subDocumentFilters}
                          modules={''}
                          subMaster={true}
                          title={'CREATE'}
                          visible={(viewOption && viewOption.resourceName === 'salesInvoice' && viewOption.viewOption === true) ? false : visible}
                          isDisabled={isDisabled}
                          resource={resource === 'PreVerificationApproval' ? 'Documents' : item && item.options.ref}
                          loading={false}
                          onChange={this.handleChange}
                          onSubmit={this.handleSubmit}
          />
        </Modal>
        {/*{!clearData && <div style={resource === 'PreVerificationApproval' ? {marginTop: '10px'} : {}}> Documents </div>}*/}
        {this.props.comeFrom === 'jobCardReport' ? '' : !clearData &&
          <div style={resource === 'PreVerificationApproval' ? {marginTop: '10px'} : {}}> Documents </div>}
        {this.props.comeFrom === 'jobCardReport' ? '' : !clearData && formItems}
        {this.props.resource === 'PreVerificationApproval' ?
          <Button
            disabled={(title === 'VIEW' && resource === 'PreVerificationApproval') ? true : title && title === 'EDIT' && resource && (resource === 'ThirdPartyWorkQuotation' || resource === 'InvoiceEntry') ? true : disableAdd ? true : isDisabled}

            type="dashed" onClick={this.showModal}
            style={resource && (resource === 'ThirdPartyWorkQuotation' || resource === 'InvoiceEntry') ? {
              width: '100%',
              marginTop: '15px'
            } : {width: '70%', marginTop: '15px'}}>
            <Icon
              type="plus"/> Add Documents
          </Button> :
          <Button
            disabled={(title === 'VIEW' && resource === 'PreVerificationApproval') ? true : title && title === 'EDIT' && resource && (resource === 'ThirdPartyWorkQuotation' || resource === 'InvoiceEntry') ? false : disableAdd ? true : isDisabled}
            type="dashed" onClick={this.showModal}
            style={resource && resource === 'jobCardReport' ? {
              marginTop: '5px'
            } : (resource === 'ThirdPartyWorkQuotation' || resource === 'InvoiceEntry') ? {
              width: '100%',
              marginTop: '15px'
            } : {width: '60%', marginTop: '15px'}}>
            <Icon
              type="plus"/> Add {sanitizeFieldName((item && item.field) || '')}
          </Button>
        }
      </div>
    )
  }
}

const mapStateToProps = ({commonData}) => {
  return {
    subDocumentFilters: commonData.subDocumentFilters
  }
};

function mapDispatchToProps(dispatch) {
  return {
    fetchSubDocumentFilter,
    deleteResource,
  };
}

export default connect(mapStateToProps, mapDispatchToProps())(DocumentList);
DocumentList.defaultProps = {};

DocumentList.propTypes = {
  item: PropTypes.object
};
